import {
  ListTodo,
  Clock,
  Loader2,
  ListChecks,
  History,
  Layers,
  LayoutDashboard,
} from "lucide-react";

import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { NumberKpiCard } from "@/components/shared/NumberKpiCard";
import { PageTabs, PageTabItem } from "@/components/shared/PageTabs";
import { TarefaAdminListTable } from "./components/TarefaAdminListTable";
import { TarefaLogAdminListTable } from "./components/TarefaLogAdminListTable";
import { useTarefaAdminKpis } from "@/hooks/use-tarefa-admin-kpis";
import { PainelTarefasTab } from "./tabs/PainelTarefasTab";

function TarefasTabContent() {
  const { resumo, loading: loadingKpis } = useTarefaAdminKpis();

  return (
    <div className="flex flex-col space-y-6">
      <div className="scrollbar-none -mx-4 flex snap-x snap-mandatory flex-col gap-4 overflow-x-auto px-4 pb-2 sm:mx-0 sm:grid sm:grid-cols-4 sm:px-0">
        <div className="min-w-[260px] flex-1 snap-center sm:min-w-0">
          <NumberKpiCard
            title="Total de Tarefas"
            value={resumo.totalGeral}
            icon={Layers}
            variant="default"
            loading={loadingKpis}
          />
        </div>
        <div className="min-w-[260px] flex-1 snap-center sm:min-w-0">
          <NumberKpiCard
            title="Tarefas Abertas"
            value={resumo.totalAbertas}
            icon={ListTodo}
            variant="blue"
            loading={loadingKpis}
          />
        </div>
        <div className="min-w-[260px] flex-1 snap-center sm:min-w-0">
          <NumberKpiCard
            title="Pendentes"
            value={resumo.totalPendentes}
            icon={Clock}
            variant="amber"
            loading={loadingKpis}
          />
        </div>
        <div className="min-w-[260px] flex-1 snap-center sm:min-w-0">
          <NumberKpiCard
            title="Em Execução"
            value={resumo.totalEmExecucao}
            icon={Loader2}
            variant="purple"
            loading={loadingKpis}
          />
        </div>
      </div>

      <TarefaAdminListTable />
    </div>
  );
}

const tabs: PageTabItem[] = [
  { value: "tarefas", label: "Tarefas", icon: ListChecks, content: <TarefasTabContent /> },
  { value: "historico", label: "Histórico", icon: History, content: <TarefaLogAdminListTable /> },
  { value: "painel", label: "Painel", icon: LayoutDashboard, content: <PainelTarefasTab /> },
];

export default function TarefaAdminListPage() {
  return (
    <div className="flex flex-col space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection title="Todas as Tarefas" />

      <PageTabs tabs={tabs} paramKey="tab" />
    </div>
  );
}
